module.exports = __webpack_public_path__ + "static/media/apcvle.55f4e680.png";